<template>
  <ChartBox
    class="wrapper-followers-by-channel"
    :description="descriptionChart"
    fullwidth
  >
    <template #title>
      <h1>
        {{ titleChart }}
        <v-tooltip
          bottom
          content-class="wrapper-followers-by-channel__tooltip"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <DsIcon
                class="wrapper-followers-by-channel__tooltip-icon"
                name="questions"
              />
            </span>
          </template>

          <span>
            O total da base de fãs/inscritos é a soma das redes sociais no último dia do período selecionado. <br><br>
            A variação das redes sociais é a comparação da data final com a data inicial do período selecionado.
          </span>
        </v-tooltip>
      </h1>
    </template>

    <div
      v-observe.once="observer"
      class="wrapper-followers-by-channel__content"
    >
      <div
        v-for="{ title, id } in groupList"
        :key="id"
      >
        <FollowersByChannel
          :chart-details="{
            groupId: id,
            groupName: title,
            titleChart
          }"
        />
      </div>
    </div>
  </ChartBox>
</template>

<script>
import { DsIcon } from '@ds/icons';

import { ChartBox } from '@/components/base';
import FollowersByChannel from './FollowersByChannel.vue';

import { dispatchMixpanelTrack } from '@/utils';

export default {
  name: 'WrapperFollowersByChannel',
  components: {
    FollowersByChannel,
    DsIcon,
    ChartBox,
  },
  computed: {
    titleChart() {
      return 'Total da base de fãs/inscritos';
    },
    descriptionChart() {
      return 'Veja a representatividade dos grupos nas redes sociais.';
    },
    observer() {
      return {
        onObserver: this.onObserver,
        options: {
          threshold: 0.5,
        },
      };
    },
    groupList() {
      return this.$store.state.ui.groupList;
    },
  },
  methods: {
    onObserver() {
      dispatchMixpanelTrack('BM FanbaseAll Graph View');
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper-followers-by-channel {
  &__tooltip {
    max-width: 219px;
    font-size: var(--ds-font-size-xs);
    line-height: var(--ds-spacing-inline-xs);
    background-color: var(--ds-color-text-1);
    opacity: 1;
    padding: var(--ds-spacing-inline-nano);
    box-shadow: var(--ds-light-dropshadow-1);
    border-radius: var(ds-border-radius--sm);

    &-icon {
      font-size: 11px;
      cursor: pointer;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-bottom-color: var(--ds-color-text-1);
    }
  }

  &__content {
    display: grid;
    grid-template-columns: minmax(299px, 1fr);
    gap: var(--ds-spacing-stack-xs);

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, minmax(299px, 1fr));
    }

    @media (min-width: 1024px) {
      grid-template-columns: repeat(3, minmax(299px, 1fr));
    }

    @media (min-width: 1360px) {
      grid-template-columns: repeat(4, minmax(299px, 1fr));
    }
  }
}

::v-deep {
  .ds-chart-box__heading h1 {
    font-size: var(--ds-font-size-lg);
  }
}
</style>

